
import React, {FC} from 'react';
import {Location} from 'components/TimePicker/types';

import Crumbs from './Crumbs';
import Details from './Details';
import Private from './Private';
import {useSlugs} from './useSlugs';

import * as styles from './styles.module.scss';

export type PartialLocation = {
	details: Partial<Location['details']> & {
		slug?: string
	}
}

type LocationNotesProps = {
	location: PartialLocation
	isPrivate?: boolean
}

const LocationNotes: FC<LocationNotesProps> = ({isPrivate, ...rest}) => {
	const slugs = useSlugs();

	// If we only have a slug (SSR), try to look up name
	let location = rest.location;
	if (location.details.slug && !location.details.name) {
		location = {
			details: {
				name: (
					slugs[location.details.slug || ''] ||
					'BodySpec ...'
				)
			}
		};
	}

	return (
		<div className={styles.wrapper}>
			<Crumbs location={location} />
			<Details
				location={location}
				isPrivate={isPrivate}
			/>
			{isPrivate && (
				<Private />
			)}
		</div>
	);
};

export default LocationNotes;
